import React, { useCallback, useState } from 'react';
import StoreFlag from './store_flag';
import styled from 'styled-components';
import { color, space, fontSize } from '@core-ds/primitives';
import { CaretDown, CaretUp } from '@core-ds/icons/16';
import withTippy from '../../dropdowns/with_tippy';
import IFixitStoreDropdown from './ifixit_store_dropdown';

const StyledCaretDown = styled(CaretDown)`
   color: ${color.gray6};
`;

const StyledCaretUp = styled(CaretUp)`
   color: ${color.white};
`;

const Button = styled.a`
   display: flex;
   align-items: center;
   margin-right: ${space[1]};

   :hover {
      text-decoration: none;

      ${StyledCaretDown} {
         color: ${color.white};
      }
   }
`;

const ButtonWithTippy = withTippy(Button);

const Currency = styled.div`
   font-family: Overpass Mono;
   font-style: normal;
   font-weight: bold;
   font-size: ${fontSize[0]};
   line-height: ${fontSize[0]};
   color: ${color.white};
   margin-right: 8px;
`;

const StoreSelector = ({ stores, dropdownState }) => {
   const currentStore = stores.find(store => store.isDisplayStore);

   const [dropdownOpen, setDropdownOpen] = dropdownState;

   return (
      <ButtonWithTippy
         id="storeDropdownToggle"
         offset="120, 0"
         onShow={() => setDropdownOpen(true)}
         onHide={() => setDropdownOpen(false)}
         content={<IFixitStoreDropdown currentStore={currentStore} stores={stores} />}
      >
         <StoreFlag
            storeCode={currentStore.storeCode}
            style={{
               marginLeft: space[4],
               marginRight: '6px',
            }}
            id="currentStore"
         />
         <Currency>{currentStore.currency}</Currency>
         {dropdownOpen ? <StyledCaretUp /> : <StyledCaretDown />}
      </ButtonWithTippy>
   );
};

export default StoreSelector;
